<template>
  <div class="item">
    <div class="item-title">
      <div>{{id ? '订单编号：' + id : '服务费'}}</div>
      <div class="time">{{time}}</div>
    </div>
    <span class="item-value">{{price}}</span>
  </div>
</template>
<script>
export default {
  name: 'detail_item',
  props: ['id', 'time', 'price']
}
</script>
<style lang="scss" scoped>
.item {
  background: #fff;
  display: -webkit-flex;
  display: flex;
  height: 1.5rem;
  align-items: center;
  padding: 0 .3rem;
  border-bottom: 1px solid #EBEBEB;
  box-sizing: border-box;
  .item-title {
    font-size: .28rem;
    flex: 2;
    line-height: 2;
    .time {
      font-size: .26rem;
      color: rgba(51, 51, 51, 0.5);
    }
  }
  .item-value {
    font-size: .26rem;
    text-align: right;
    flex: 1;
    font-size: .28rem;
    color:#02B389;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order_item.vue